/* @flow */
import QSUtil from './QSUtil.js'

export default class HistoryHelper{
	static push(key, value='o', state=null){
		history.pushState(state, "", QSUtil.addToQs(key, value));
	}

	static back(){
		history.back();
	}

	static replace(key, value=null){
		let qs = '';
		if(value){
			qs = QSUtil.addToQs(key, value);
		} else {
			qs = QSUtil.removeFromQs(key);
		}
		history.replaceState(null, "", qs);
	}

	static shouldBeVisible(key){
		return QSUtil.includes(key);
	}
}